import { useEffect, useState } from 'react';
import { useSesion } from './auth/ProveedorSesion';
import { cerrarSesion, iniciarSesion } from './auth/msal';
import { Encabezado, type Vista } from './componentes/Encabezado';
import { EsqueletoArranque } from './componentes/Esqueletos';
import { PantallaMensaje } from './componentes/Estados';
import { PantallaLogin } from './vistas/PantallaLogin';
import { VistaAdmin } from './vistas/admin/VistaAdmin';
import { VistaColaborador } from './vistas/colaborador/VistaColaborador';

const boton =
  'rounded-[10px] bg-lima px-5 py-2.5 font-titulo text-[13.5px] font-bold text-tinta transition-colors hover:bg-lima-claro';

export function App() {
  const { estado, sesion, errorSesion, cargandoSesion } = useSesion();
  const [vista, setVista] = useState<Vista>('colaborador');

  // Si a un administrador le sacan el permiso mientras navega, no lo dejamos
  // parado en una pantalla que ya no le corresponde.
  useEffect(() => {
    if (sesion && !sesion.esAdmin && vista === 'admin') setVista('colaborador');
  }, [sesion, vista]);

  if (estado === 'sin-config') {
    return (
      <PantallaMensaje titulo="Falta configurar Entra ID">
        <p>
          El archivo <code className="text-cian">frontend/.env</code> no tiene cargados{' '}
          <code className="text-cian">VITE_ENTRA_TENANT_ID</code> y{' '}
          <code className="text-cian">VITE_ENTRA_CLIENT_ID</code>.
        </p>
        <p>
          El paso a paso para sacarlos del portal está en el <strong>README.md</strong>, en la
          sección «Registrar la app en Microsoft Entra ID».
        </p>
      </PantallaMensaje>
    );
  }

  if (estado === 'iniciando') return <EsqueletoArranque texto="Verificando tu sesión…" />;
  if (estado === 'anonimo') return <PantallaLogin />;

  if (errorSesion?.esSinPermiso) {
    return (
      <PantallaMensaje
        titulo="Tu cuenta no tiene acceso"
        accion={
          <button type="button" className={boton} onClick={() => void cerrarSesion()}>
            Cerrar sesión
          </button>
        }
      >
        <p>{errorSesion.message}</p>
        <p>Si creés que es un error, pedile a Sistemas que te agregue al grupo de la App Eventos.</p>
      </PantallaMensaje>
    );
  }

  if (errorSesion) {
    return (
      <PantallaMensaje
        titulo="No se pudo abrir tu sesión"
        accion={
          <div className="flex flex-wrap gap-3">
            <button type="button" className={boton} onClick={() => window.location.reload()}>
              Reintentar
            </button>
            <button
              type="button"
              className="rounded-[10px] border border-white/15 px-5 py-2.5 text-[13.5px] text-suave transition-colors hover:bg-white/5"
              onClick={() => void iniciarSesion()}
            >
              Volver a iniciar sesión
            </button>
          </div>
        }
      >
        <p>{errorSesion.message}</p>
        <p className="text-xs text-mudo">
          Si el backend no está levantado, corré <code className="text-cian">npm run dev</code> en la
          raíz del proyecto.
        </p>
      </PantallaMensaje>
    );
  }

  if (cargandoSesion || !sesion) return <EsqueletoArranque texto="Cargando tu perfil…" />;

  return (
    <div className="flex min-h-full flex-col">
      <Encabezado sesion={sesion} vista={vista} onVista={setVista} />
      <main className="flex-1">
        {vista === 'admin' && sesion.esAdmin ? <VistaAdmin /> : <VistaColaborador />}
      </main>
    </div>
  );
}
